import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import Collection from 'assets/components/data/Collection';
import Row from 'assets/components/data/rows/Row';
import RowActions from 'assets/components/data/rows/RowActions';
import RowData from 'assets/components/data/rows/RowData';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageError from 'assets/components/page/themes/Theme.Page.Error';
import { getLocales } from 'assets/locales/Locale';
import HeaderRow from 'assets/components/data/rows/HeaderRow';
import HeaderData from 'assets/components/data/rows/HeaderData';
import DealerGroup from 'models/dealerManagement/dealerGroup/Model.DealerGroup';
import { useProductEnhancementDealerGroupDocumentProvider } from '../ProductEnhancementDocument.DealerGroupDocuments.Hooks';
import ThemeCollectionList from 'assets/components/data/themes/Theme.Collection.List';
import UploadDocumentTranslationButton from 'module/productManagement/components/translations/UploadDocumentTranslationButton';

export default function DealerGroupDocumentList() {
  const { lang } = getLocales();
  const {
    dealerGroupDocumentList,
    selectedItems,
    toggleItem,
    reloadTranslatedDocs,
    selectedTranslatedItems,
    toggleTranslatedItem,
    translatedDocumentList,
  } = useProductEnhancementDealerGroupDocumentProvider();

  return dealerGroupDocumentList.count == 0 ? (
    <Page
      class={ThemePageError}
      sidebar={<Icon class="fas-clipboard-list" />}
      header={lang.documents}
      render={lang.noInfo}
    />
  ) : (
    <Collection class={ThemeCollectionList}>
      <HeaderRow>
        <HeaderData>{lang.dealerGroup}</HeaderData>
        <HeaderData>{lang.document}</HeaderData>
        <HeaderData>{lang.translations}</HeaderData>
        <HeaderData numOfActions={1} />
      </HeaderRow>
      <DataMap
        data={dealerGroupDocumentList.data?.map((x) => ({ ...x, dealerGroup: new DealerGroup(x.dealerGroup) }))}
        render={({ data: productDealerGroupDocument }) => {
          const isDocumentSelected = selectedItems?.some(
            (it) => it.dealerGroupId === productDealerGroupDocument.dealerGroupId
          );
          const translations =
            translatedDocumentList?.filter((it) => it.documentId === productDealerGroupDocument.id) ?? [];
          const areTranslationsSelected = translations?.every((it) =>
            selectedTranslatedItems.some((t) => t.id === it.id)
          );
          return (
            <Row
              key={productDealerGroupDocument.dealerGroupId}
              children={
                <>
                  <RowData {...productDealerGroupDocument.dealerGroup.displayInfo} />
                  <RowData>{productDealerGroupDocument.mediaFile?.name ?? '-'}</RowData>
                  <RowData>
                    <UploadDocumentTranslationButton
                      documentId={productDealerGroupDocument.id}
                      documentType="ProductEnhancementDealerGroupDocument"
                      translatedDocuments={translations}
                      onFinish={reloadTranslatedDocs}
                    />
                  </RowData>
                  <RowActions>
                    <Button
                      data={productDealerGroupDocument}
                      onClick={toggleItem}
                      class={ThemeButtonCircle}
                      media={<Icon class={isDocumentSelected ? 'fas-check-square' : 'far-square'} />}
                      htmlElementProps={{ title: isDocumentSelected ? lang.unselect : lang.select }}
                      active
                    />
                    <Button
                      data={translations}
                      onClick={toggleTranslatedItem}
                      class={ThemeButtonCircle}
                      disabled={isDocumentSelected || !translations?.length}
                      media={
                        <Icon
                          class={
                            (areTranslationsSelected || isDocumentSelected) && translations?.length
                              ? 'fas-check-square'
                              : 'far-square'
                          }
                        />
                      }
                      htmlElementProps={{ title: areTranslationsSelected ? lang.unselect : lang.select }}
                      active
                    />
                  </RowActions>
                </>
              }
            />
          );
        }}
      />
    </Collection>
  );
}
